import {useGooglePoiTravelDirections} from "../../maps/hooks/use_google_poi_travel_directions";
import {IPoi} from "../../maps/types/IPoi";
import {IUserPoi} from "../../maps/types/IUserPoi";
import {PoiType} from "../../maps/utils/PoiType";
import {formatDuration, TravelMode} from "../../property/utils/TravelMode";

export const useCalculateTravelTime = () => {
    //  TODO:
    //   Implementation of this hook should be changed to something else after the maps rewrite
    //   Below hook beside providing a travel time, also adds new data to redux and we don't need that here
    //   Ideally, below hook should be rewritten to provide just the api handler/facade for this operation
    const {getPoiDirections} = useGooglePoiTravelDirections();

    return async function (poi: IPoi | IUserPoi, poiType: PoiType, targetCoords: [number, number], travelMode: TravelMode) {
        const directions = await getPoiDirections(poi, poiType, targetCoords, travelMode);

        if (directions) {
            return formatDuration(directions.duration, "m") || "1 m";
        } else {
            console.warn("Directions not received for ", poi.name);
            return "-";
        }
    };
};
import {useGooglePoiTravelDirections} from "../../maps/hooks/use_google_poi_travel_directions";
import {IPoi} from "../../maps/types/IPoi";
import {IUserPoi} from "../../maps/types/IUserPoi";
import {PoiType} from "../../maps/utils/PoiType";
import {formatDuration, TravelMode} from "../../property/utils/TravelMode";

export const useCalculateTravelTime = () => {
    //  TODO:
    //   Implementation of this hook should be changed to something else after the maps rewrite
    //   Below hook beside providing a travel time, also adds new data to redux and we don't need that here
    //   Ideally, below hook should be rewritten to provide just the api handler/facade for this operation
    const {getPoiDirections} = useGooglePoiTravelDirections();

    return async function (poi: IPoi | IUserPoi, poiType: PoiType, targetCoords: [number, number], travelMode: TravelMode) {
        const directions = await getPoiDirections(poi, poiType, targetCoords, travelMode);

        if (directions) {
            return formatDuration(directions.duration, "m") || "1 m";
        } else {
            console.warn("Directions not received for ", poi.name);
            return "-";
        }
    };
};
